/**
 * Site desenvolvido para divulgação das especializações de odontologia
 *
 * @version 1.0.0
 * @author [Renato Alves](https://github.com/renatociqueira)
 */

import React from "react";
import Layoutcursos from "../../Layout/Cursoslayout";
import './Imaginologia.css';
import '../Endodontia/Endodontia.css';

const Imaginologia = () => {

    
    return(
       <>
        <Layoutcursos>
        </Layoutcursos>
        <img src="/images/professores/marinalemmosl.png" className="img-endodontia" alt="professor"></img>
                <div className="conteudopublico">
                    <p> CIRURGIÕES-DENTISTAS </p>
                </div>
                <div className="conteudodiferenciais">
                    <p> -PRÁTICAS CLÍNICAS COM TOMÓGRAFO CONE-BEAM <br/>
                            -MATRIZ CURRICULAR ATUALIZADA COM ODONTOLOGIA DIGITAL <br/>
                            -PROFESSORES CONVIDADOS DE REFERÊNCIA NA ÁREA <br/>
                            -PRÁTICAS DE INTERPRETAÇÃO E CONFECÇÃO DE LAUDOS COM PACIENTES
                            </p>
                    
                </div>
                <div className="professor">
                    <p id="prof">PROFª.</p><br/>
                    <strong id="coordenacao">Marina Castro Lemmos Lopes Cardoso</strong><br/><br/>
                    <p className="curriculo">Graduada em Odontologia pela UFRN, Mestre em Ciências Odontológicas 
                                                    pela UFRN, Especialista em Radiologia Odontológica e Imaginologia 
                                                    pela ABO/PB. Atua como docente de Imaginologia do Curso de Odontologia 
                                                    do UNIFACEX. É Membro Fundadora, como Professora Presidente Orientadora, 
                                                    da Liga de Odontologia Digital do Rio Grande do Norte, além de ser Diretora 
                                                    do Centro de Imagem Odontológica do Seridó (CIOS).
                    </p>

                    <br/> <div className="convidados">
                    <strong>CONVIDADOS</strong><br/>                                
                    <details>
                        <small>
                            ALBERTO COSTA GURGEL (UNIFACEX-RN) <br/>
                            BRUNO MAIA <br/>
                            CIRO DANTAS SOARES <br/>
                            CLAUDINE VALÉRIA CORREIA SOUSA (UNIFACEX-RN) <br/>
                            HANIERI GUSTAVO DE OLIVEIRA (UERN) <br/>
                            PAULO SÉRGIO FLORES CAMPOS (UFBA)
                        </small>
                    </details>
                    </div><br/>
                    <div className="professores">
                        <strong>PROFESSORES</strong><br/>                                
                        <details>
                            {/* <summary> PROFESSORES </summary> */}
                            <small>
                                CONCEIÇÃO APARECIDA DORNELAS MONTEIRO MAIA<br/>
                                PAULO RAPHAEL LEITE MAIA <br/>
                            </small>
                        </details><br/><br/> 
                    </div> 

                </div>
                <div id="tipodepagamento">
                    <p className="encontro-conteudo">MENSALMENTE | QUARTA A SÁBADO</p>
                    {/* <small className="encontro-horarios">8H ÀS 12H E DAS 13H30 DAS 17H30</small> */}
                    <p className="cargahoraria-conteudo">855 HORAS</p>
                    <p className="tipoaula-conteudo">PRESENCIAL </p>
                    <p className="parcelas">24X</p>
                    <p className="R">R$</p>
                    <h1 className="valor">1.300,00</h1>
                    <p className="pagamento-info">PAGAMENTO NO CARTÃO OU NO BOLETO ATÉ A DATA DO VENCIMENTO</p>
                </div>
                <div>
                    <strong className="titulo-curso">ESPECIALIZAÇÃO EM RADIOLOGIA ODONTOLÓGICA E IMAGINOLOGIA</strong>   
                </div>
                <div className="conteudo-curso">
                    <p>
                    A especialidade de RADIOLOGIA ODONTOLÓGICA E IMAGINOLOGIA possui a característica marcante de auxiliar o diagnóstico nas diversas áreas da odontologia, a partir do uso de variados equipamentos de imagem. O crescente avanço tecnológico tem trazido novas perspectivas para essa especialidade que tem ampliado seus campos de ação com a inserção da tomografia computadorizada feixe cônico, a ultrassonografia e a ressonância magnética. Além de novas vertentes, o crescimento recente do trabalho remoto tem impactado positivamente na rotina do radiologista, que já não precisa estar presencialmente na clínica, rompendo barreiras geográficas e flexibilizando a jornada de trabalho desse profissional.                 
                   <br/><br/> O aluno da nossa ESPECIALIZAÇÃO EM RADIOLOGIA ODONTOLÓGICA E IMAGINOLOGIA terá a oportunidade de desenvolver-se nas várias áreas do diagnóstico por imagem, praticando em todos os módulos do curso a aquisição de imagens radiográficas, tomográficas e a interpretação de exames realizados em pacientes, inclusive vivenciando a realidade dinâmica de um serviço especializado de radiologia.
                   <br/> Nossa matriz curricular foi planejada agregando as temáticas mais modernas, inclusive a odontologia digital, uma área inovadora que está ampliando a uma grande velocidade. Sendo a radiologia uma especialidade naturalmente interligada à odontologia digital entende-se que o RADIOLOGISTA que tem uma formação moderna e já ampliada para o fluxo digital consegue conquistar espaço no mercado de trabalho rapidamente. A combinação de uma estrutura física moderna, equipamentos de tecnologia avançada e professores experientes permitirá a formação de um especialista COMPLETO E ALTAMENTE ATUALIZADO.  
                    Venha fazer parte dessa turma que quer construir um diagnóstico por imagem na odontologia de excelência.

                    </p>
                </div>
                <a href={`${process.env.PUBLIC_URL}/Files/pdf/Matriz-Imaginologia.pdf`} rel="noreferrer" target='_blank' download><button className="Matriz" ><h4>MATRIZ CURRICULAR</h4></button></a>
       </> 
    )
};

export default Imaginologia;